export const setUser = (user) => localStorage.setItem('user', user)
export const getUser = () => JSON.parse(localStorage.getItem('user'))
export const setToken = (token) => localStorage.setItem('token', token)
export const getToken = () => localStorage.getItem('token')
export const setRefreshToken = (token) =>
  localStorage.setItem('refreshToken', token)
export const getRefreshToken = () => localStorage.getItem('refreshToken')

export const removeUser = () => localStorage.removeItem('user')
export const removeToken = () => localStorage.removeItem('token')
export const removeRefreshToken = () => localStorage.removeItem('refreshToken')
// export const removeUser = () => console.log("REMOVE USER");//localStorage.removeItem('user');
// export const removeToken = () => console.log("REMOVE TOKEN");//localStorage.removeItem('token');
// export const removeRefreshToken = () => console.log("REMOVE REFRESHTOKEN");//localStorage.removeItem('refreshToken');
